module.exports = __webpack_public_path__ + "static/k3-56fcfe79c63e752d9024d24ca668370c.jpg";